import { types, actions } from './requests'
export const CREATEMACHINE_TYPES = {
    ...types('CREATEMACHINE'),
}
export const CREATEMACHINE_ACTIONS = {
    ...actions('CREATEMACHINE'),
}
